module.exports = __webpack_public_path__ + "static/media/shopify1.3cfe51f2.png";